'use client';

import type { ReactNode } from 'react';
import { IconButton, Tooltip } from '@terra/ui-design-system';
import { Box } from '@terra/ui-styled-system';

export function ListPageBulkActionButton({
  label,
  tooltip,
  icon,
  isDisabled,
  onClick,
  dataTourId,
}: {
  label: string;
  tooltip: string;
  icon: ReactNode;
  isDisabled: boolean;
  onClick: () => void;
  dataTourId?: string;
}) {
  return (
    <Tooltip title={tooltip}>
      <Box display="inline-flex" flexShrink={0} data-tour-id={dataTourId}>
        <IconButton
          aria-label={label}
          size="xs"
          variant="ghost"
          disabled={isDisabled}
          onClick={onClick}
        >
          {icon}
        </IconButton>
      </Box>
    </Tooltip>
  );
}
